module.exports = __webpack_public_path__ + "static/img/ind_ban_09.7be07ddb.jpeg";